const pagesA = [
  {
    id: 815,
    type: 0,
    kuerzel: "A 1",
    template_file: "",
    kapitel: 1,
    titel: "Büro",
    filename: "buero",
    printfile: "",
    verweis_titel: "Physikalisch-technische Grundlagen",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 860,
        type: 0,
        kuerzel: "A 1.1",
        template_file: "",
        kapitel: 1,
        titel: "Büro",
        filename: "prueffristen",
        printfile: "",
        verweis_titel: "Physikalisch-technische Grundlagen - Einleitung",
        mediaquery: 0,
        pagenumber: "0",
        pages: [
          {
            id: 652,
            type: 1,
            kuerzel: "A 1.1.1",
            template_file: "",
            kapitel: 1,
            titel: "Prüffristen",
            filename: "prueffristen",
            printfile: "",
            verweis_titel: "Kraft",
            mediaquery: 0,
            pagenumber: "0"
          }
        ]
      },

      {
        id: 816,
        type: 0,
        kuerzel: "A 1.2",
        template_file: "",
        kapitel: 1,
        titel: "Unterweisungen",
        filename: "untweisungen",
        printfile: "",
        verweis_titel: "Festigkeitslehre",
        mediaquery: 0,
        pagenumber: "0",
        pages: [
          {
            id: 657,
            type: 1,
            kuerzel: "A 1.2.1",
            template_file: "",
            kapitel: 1,
            titel: "Durchführungen",
            filename: "durchfuehrungen",
            printfile: "",
            verweis_titel: "Festigkeitslehre - Einleitung",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 658,
            type: 1,
            kuerzel: "A 1.2.2",
            template_file: "",
            kapitel: 1,
            titel: "Teilnahme",
            filename: "beansprungungsarten",
            printfile: "",
            verweis_titel: "Beanspruchungsarten",
            mediaquery: 0,
            pagenumber: "0"
          }
        ]
      }
    ]
  },

  {
    id: 867,
    type: 0,
    kuerzel: "A 2",
    template_file: "",
    kapitel: 1,
    titel: "Eingang chemisches Labor",
    filename: "eingang_chem_labor",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 868,
        type: 1,
        kuerzel: "A 2.1",
        template_file: "",
        kapitel: 1,
        titel: "Labortür",
        filename: "labortueren",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 869,
        type: 1,
        kuerzel: "A 2.2",
        template_file: "",
        kapitel: 1,
        titel: "Augennotdusche",
        filename: "augennotdusche",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 870,
        type: 1,
        kuerzel: "A 2.3",
        template_file: "",
        kapitel: 1,
        titel: "Körpernotdusche",
        filename: "koerpernotdusche",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 871,
        type: 1,
        kuerzel: "A 2.4",
        template_file: "",
        kapitel: 1,
        titel: "Ventil / Kennzeichnung",
        filename: "ventil",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 872,
    type: 0,
    kuerzel: "A 3",
    template_file: "",
    kapitel: 1,
    titel: "Rettungseinrichtungen",
    filename: "rett_einrichtung",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 873,
        type: 1,
        kuerzel: "A 3.1",
        template_file: "",
        kapitel: 1,
        titel: "Zugänglichkeit",
        filename: "zugaenglichkeit",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 874,
        type: 1,
        kuerzel: "A 3.2",
        template_file: "",
        kapitel: 1,
        titel: "Verbandkasten",
        filename: "verbandkasten",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 875,
        type: 1,
        kuerzel: "A 3.3",
        template_file: "",
        kapitel: 1,
        titel: "Feuerlöscher",
        filename: "feuerloescher",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 876,
    type: 0,
    kuerzel: "A 4",
    template_file: "",
    kapitel: 1,
    titel: "Chemikalien",
    filename: "chemikalien",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 877,
        type: 1,
        kuerzel: "A 4.1",
        template_file: "",
        kapitel: 1,
        titel: "Regal",
        filename: "regal",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 878,
        type: 1,
        kuerzel: "A 4.2",
        template_file: "",
        kapitel: 1,
        titel: "Sicherheitsschrank",
        filename: "sicherheitsschrank",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 879,
    type: 0,
    kuerzel: "A 5",
    template_file: "",
    kapitel: 1,
    titel: "Druckgasflaschenschrank",
    filename: "druckgasflaschenschrank",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 880,
        type: 1,
        kuerzel: "A 5.1",
        template_file: "",
        kapitel: 1,
        titel: "Druckgasflasche",
        filename: "druckgasflasche",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 881,
    type: 0,
    kuerzel: "A 6",
    template_file: "",
    kapitel: 1,
    titel: "Apparaturen",
    filename: "apparaturen",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 882,
        type: 0,
        kuerzel: "A 6.1",
        template_file: "",
        kapitel: 1,
        titel: "Apparaturen",
        filename: "funk_des_Abzugs",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0",
        pages: [
          {
            id: 883,
            type: 1,
            kuerzel: "A 6.1.1",
            template_file: "",
            kapitel: 1,
            titel: "Funktionsprüfung des Abzugs",
            filename: "funk_des_Abzugs",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          }
        ]
      },

      {
        id: 884,
        type: 0,
        kuerzel: "A 6.2",
        template_file: "",
        kapitel: 1,
        titel: "Versuchsaufbau im Abzug",
        filename: "versuch_im_Abzug",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0",
        pages: [
          {
            id: 885,
            type: 1,
            kuerzel: "A 6.2.1",
            template_file: "",
            kapitel: 1,
            titel: "Hebebühne",
            filename: "hebebuehne",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 886,
            type: 1,
            kuerzel: "A 6.2.2",
            template_file: "",
            kapitel: 1,
            titel: "Tauchsieder",
            filename: "tauchsieder",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 887,
            type: 1,
            kuerzel: "A 6.2.3",
            template_file: "",
            kapitel: 1,
            titel: "Rundkolben",
            filename: "rundkolben",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 888,
            type: 1,
            kuerzel: "A 6.2.4",
            template_file: "",
            kapitel: 1,
            titel: "Statische Sicherung",
            filename: "statische_sicherung",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 889,
            type: 1,
            kuerzel: "A 6.2.5",
            template_file: "",
            kapitel: 1,
            titel: "Schliffsicherung",
            filename: "schliffsicherung",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          },

          {
            id: 890,
            type: 1,
            kuerzel: "A 6.2.6",
            template_file: "",
            kapitel: 1,
            titel: "Schlauchsicherung",
            filename: "schlauchsicherung",
            printfile: "",
            verweis_titel: "",
            mediaquery: 0,
            pagenumber: "0"
          }
        ]
      }
    ]
  },

  {
    id: 891,
    type: 0,
    kuerzel: "A 7",
    template_file: "",
    kapitel: 1,
    titel: "Mitarbeiter",
    filename: "mitarbeiter",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 892,
        type: 1,
        kuerzel: "A 7.1",
        template_file: "",
        kapitel: 1,
        titel: "Ärmel des Laborkittels",
        filename: "aermel_des_Labor",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 893,
        type: 1,
        kuerzel: "A 7.2",
        template_file: "",
        kapitel: 1,
        titel: "Laborkittel",
        filename: "laborkittel",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 894,
        type: 1,
        kuerzel: "A 7.3",
        template_file: "",
        kapitel: 1,
        titel: "Schuhe",
        filename: "schuhe",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 895,
        type: 1,
        kuerzel: "A 7.4",
        template_file: "",
        kapitel: 1,
        titel: "Laborbrille",
        filename: "laborbrille",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 896,
        type: 1,
        kuerzel: "A 7.5",
        template_file: "",
        kapitel: 1,
        titel: "Rauchen",
        filename: "rauchen",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 897,
        type: 1,
        kuerzel: "A 7.6",
        template_file: "",
        kapitel: 1,
        titel: "Essen und Trinken",
        filename: "essen_und_trinken",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 898,
    type: 0,
    kuerzel: "A 8",
    template_file: "",
    kapitel: 1,
    titel: "Eingang biotechnologisches Labor",
    filename: "eingang_bio_Labor",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 899,
        type: 1,
        kuerzel: "A 8.1",
        template_file: "",
        kapitel: 1,
        titel: "Labortür",
        filename: "labortuer",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 900,
    type: 0,
    kuerzel: "A 9",
    template_file: "",
    kapitel: 1,
    titel: "Waschbecken und Garderobe",
    filename: "waschbecken_garderobe",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 901,
        type: 1,
        kuerzel: "A 9.1",
        template_file: "",
        kapitel: 1,
        titel: "Händewaschen",
        filename: "haendewaschen",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 902,
        type: 1,
        kuerzel: "A 9.2",
        template_file: "",
        kapitel: 1,
        titel: "Persönliche Schutzausrüstung",
        filename: "pers_ausruestung",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 903,
    type: 0,
    kuerzel: "A 10",
    template_file: "",
    kapitel: 1,
    titel: "Arbeitsplatz",
    filename: "arbeitsplatz",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 904,
        type: 1,
        kuerzel: "A 10.1",
        template_file: "",
        kapitel: 1,
        titel: "Belüftung",
        filename: "belueftung",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 905,
        type: 1,
        kuerzel: "A 10.2",
        template_file: "",
        kapitel: 1,
        titel: "Arbeitsorganisation",
        filename: "arbeitsorganisation",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 906,
        type: 1,
        kuerzel: "A 10.3",
        template_file: "",
        kapitel: 1,
        titel: "Hygieneplan",
        filename: "hygieneplan",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 907,
    type: 0,
    kuerzel: "A 11",
    template_file: "",
    kapitel: 1,
    titel: "Mikrobiologische Sicherheitswerkbank",
    filename: "mikrobiologische",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 908,
        type: 1,
        kuerzel: "A 11.1",
        template_file: "",
        kapitel: 1,
        titel: "Arbeitsmittel",
        filename: "arbeitsmittel",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 909,
        type: 1,
        kuerzel: "A 11.2",
        template_file: "",
        kapitel: 1,
        titel: "Arbeitshaltung und Schutzhandschuhe",
        filename: "arbeitshaltung",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },
      {
        id: 910,
        type: 1,
        kuerzel: "A 11.3",
        template_file: "",
        kapitel: 1,
        titel: "Pipetten",
        filename: "pipetten",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  },

  {
    id: 911,
    type: 0,
    kuerzel: "A 12",
    template_file: "",
    kapitel: 1,
    titel: "Sterilisationsautoklav",
    filename: "sterilisationsautoklav",
    printfile: "",
    verweis_titel: "",
    mediaquery: 0,
    pagenumber: "0",
    pages: [
      {
        id: 912,
        type: 1,
        kuerzel: "A 12.1",
        template_file: "",
        kapitel: 1,
        titel: "Persönliche Schutzausrüstung",
        filename: "pers_schutz",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 913,
        type: 1,
        kuerzel: "A 12.2",
        template_file: "",
        kapitel: 1,
        titel: "Ausstattung und Entladung des Autoklaven",
        filename: "ausstatung_entladung",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      },

      {
        id: 914,
        type: 1,
        kuerzel: "A 12.3",
        template_file: "",
        kapitel: 1,
        titel: "Prüfung der Wirksamkeit",
        filename: "pruefung_der_wirksamkeit",
        printfile: "",
        verweis_titel: "",
        mediaquery: 0,
        pagenumber: "0"
      }
    ]
  }
];
export default pagesA;
